import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import DiscountBadge from './discountBadge';
import { formatMoney } from '../../../../helpers/formatters';

interface ItemNewPriceProps extends WithTranslation {
    currencies?: any[];
    newPrice: number;
}

const ItemNewPrice = (
    {
        currencies,
        newPrice,
        t,
        i18n,
    }: ItemNewPriceProps
) => {
    const lng = i18n.language;
    const currenciesArr = currencies ? currencies : ['NOK'];
    return (
        <>
            {currenciesArr.map(currency => (
                <DiscountBadge key={currency}>
                    {t('customers.customer.discounts.new_price')}: {formatMoney(lng, newPrice, currency)}
                </DiscountBadge>
            ))}
        </>
    );
};

export default withTranslation()(ItemNewPrice);
